import React from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "types/store";
import { Button } from "aible";
import Select from "react-select";
import * as homeReducer from "containers/Home/reducer";
import styles from "./style.module.css";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import * as nextReducer from "containers/Next/NextReducer";
import ComparisonDashboard from "components/Next/Dashboard/ComparisonDashboard";
import NextSearchContainer from "containers/Next/NextSearch";
import { KPIDeepDiveExcludeColumnsSetting } from "components/KPIAnalysis/KPIAdvancedSettings";
import * as reportReducer from "containers/Report/ReportReducer";
const KPIDeepDiveSetup = ({ targetKPI }) => {
    const dispatch = useDispatch();
    const hasKPIDeepDive = useSelector((state) => chatGPTReducer.getHasKPIDeepDive(state, targetKPI));
    const KPIDeepDiveStatus = useSelector((state) => chatGPTReducer.getKPIDeepDiveStatus(state, targetKPI));
    const isLoading = useSelector((state) => chatGPTReducer.getKPIDeepDiveIsLoading(state, targetKPI));
    const isError = useSelector((state) => chatGPTReducer.getKPIDeepDiveIsError(state, targetKPI));
    const nNextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const nDatasetId = useSelector((state) => nextReducer.getDatasetId(state, nNextId));
    const KPIDeepDiveExcludeColumns = useSelector((state) => chatGPTReducer.getKPIDeepDiveExcludeColumns(state, targetKPI));
    const updateKPIDeepDiveExcludeColumns = (data) => {
        const retData = data?.filter((d) => d !== targetKPI);
        dispatch(chatGPTReducer.updateKPIDeepDiveExcludeColumns(targetKPI, retData));
    };
    const KPIDeepDiveExcludeColumnOptions = useSelector((state) => homeReducer.getKPIAnalysisDeepDiveExcludeColumnOptions(state, nDatasetId))?.filter((o) => o !== targetKPI);
    if (String(nNextId) === "new") {
        return (React.createElement("div", { className: styles.kpiDeepDiveSetup },
            React.createElement("div", { className: styles.kpiDeepDiveText, style: { maxWidth: "250px" } }, "Your Analysis is still in progress, please wait for it to complete and save before starting a deep dive into " +
                targetKPI)));
    }
    return (React.createElement("div", { className: styles.kpiDeepDiveSetup }, isLoading || isError ? (React.createElement(KPIDeepDiveLoading, { targetKPI: targetKPI })) : (React.createElement(React.Fragment, null,
        React.createElement(KPIDeepDiveExcludeColumnsSetting, { KPIDeepDiveExcludeColumns: KPIDeepDiveExcludeColumns, updateKPIDeepDiveExcludeColumns: updateKPIDeepDiveExcludeColumns, KPIDeepDiveExcludeColumnOptions: KPIDeepDiveExcludeColumnOptions, menuPlacement: "bottom" }),
        React.createElement("div", { className: styles.kpiDeepDiveActions },
            React.createElement(Button, { onClick: () => {
                    dispatch(chatGPTReducer.handleCreateKPIDeepDive(targetKPI));
                } }, "Analyze " + targetKPI))))));
};
const KPIDeepDiveLoading = ({ targetKPI }) => {
    const dispatch = useDispatch();
    const isError = useSelector((state) => chatGPTReducer.getKPIDeepDiveIsError(state, targetKPI));
    const KPIDeepDiveStatus = useSelector((state) => chatGPTReducer.getKPIDeepDiveStatus(state, targetKPI));
    const KPIDeepDiveDatasetId = useSelector((state) => chatGPTReducer.getKPIDeepDiveDatasetId(state, targetKPI));
    const insightCombinationCount = useSelector((state) => nextReducer.getInsightCombinationCount(state, undefined, KPIDeepDiveDatasetId));
    if (isError) {
        return (React.createElement("div", { className: styles.kpiDeepDiveLoadingWrapper },
            React.createElement("div", { className: styles.kpiDeepDiveText }, "Something went wrong! Please try again."),
            React.createElement(Button, { onClick: () => dispatch(chatGPTReducer.resetKPIDeepDive(targetKPI)) }, "Retry Analysis")));
    }
    let loadingMessage = "Loading...";
    if (insightCombinationCount && insightCombinationCount > 0) {
        loadingMessage = "Analyzing " + insightCombinationCount + " Combinations...";
    }
    else if (KPIDeepDiveStatus === "CREATING_DATASET") {
        loadingMessage = "Preparing data to analyze...";
    }
    else if (KPIDeepDiveStatus === "CREATING_EXPLORE") {
        loadingMessage = "Analyzing " + targetKPI + "...";
    }
    return (React.createElement("div", { className: styles.kpiDeepDiveLoadingWrapper },
        React.createElement(LoadingIndicator, null),
        React.createElement("div", { className: styles.kpiDeepDiveText }, loadingMessage)));
};
const KPIDeepDiveDashboard = ({ targetKPI }) => {
    const dispatch = useDispatch();
    const nextId = useSelector((state) => chatGPTReducer.getKPIDeepDiveNextId(state, targetKPI));
    const datasetId = useSelector((state) => chatGPTReducer.getKPIDeepDiveDatasetId(state, targetKPI));
    const [selectedNextId, setSelectedNextId] = useState(nextId);
    const [isLoading, setIsLoading] = useState(false);
    const retNextId = selectedNextId ?? nextId;
    const retDatasetId = useSelector((state) => nextReducer.getDatasetId(state, selectedNextId));
    if (!nextId && !datasetId) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: styles.kpiDeepDiveDashboard },
        React.createElement(NextSearchContainer, { id: retNextId, isOnlySearch: true, hideMargins: true, isDashboard: true, useReportIdForChatGPTReducer: true, style: { position: "relative", top: "0px", marginLeft: "0px" } }),
        nextId ? (React.createElement(FocusedDeepDiveSelector, { parentNextId: nextId, currentNextId: retNextId ?? nextId, updateCurrentNextId: setSelectedNextId, setIsLoading: setIsLoading })) : null,
        isLoading ? (React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", width: "100%", marginTop: 20 } },
            React.createElement(LoadingIndicator, null),
            "Loading Deep Dive...")) : (React.createElement("div", { style: { flexGrow: 1, width: "100%" } },
            React.createElement(ComparisonDashboard, { datasetId: retDatasetId, id: retNextId, isSmall: true, hideSearch: true, hideFocusedDeepDive: true, useReportIdForChatGPTReducer: true, forceShowCharts: true })))));
};
const FocusedDeepDiveSelector = ({ parentNextId, currentNextId, updateCurrentNextId, setIsLoading }) => {
    const dispatch = useDispatch();
    const linkedComparisonProjects = useSelector((state) => nextReducer.getLinkedComparisonProjects(state, parentNextId)) ?? {};
    const focusModeOptions = useSelector((state) => nextReducer.getLinkedComparisonFocusOptions(state, parentNextId));
    const handleOnChange = (val) => {
        return dispatch(async (dispatch, getState) => {
            const cNextId = val.value;
            const cDatasetId = nextReducer.getDatasetId(getState(), cNextId);
            updateCurrentNextId(cNextId);
            const cReport = nextReducer.getNext(getState(), cNextId);
            setIsLoading(true);
            // Fetch the report and dataset for the focused deepdive if they're not fetched yet
            try {
                if (Object.keys(cReport).length === 0) {
                    await dispatch(reportReducer.fetchReport(cNextId));
                }
                await dispatch(homeReducer.fetchDataset(cDatasetId, undefined, true));
            }
            catch (e) {
                console.log(e);
            }
            setIsLoading(false);
            return;
        });
    };
    if (!focusModeOptions?.length) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: styles.linkedSelect },
        React.createElement("div", { style: { width: "100%" } },
            React.createElement(Select, { options: focusModeOptions, onChange: handleOnChange, value: focusModeOptions.find((k) => Number(k?.value) === Number(currentNextId)), menuPlacement: "bottom", styles: {
                    menu: (baseStyles) => ({
                        ...baseStyles,
                        minWidth: "220px",
                        right: 0,
                        width: "100%"
                    })
                }, placeholder: "Select Focused Deep Dive" }))));
};
const KPIDeepDive = (props) => {
    const { targetKPI } = props;
    const dispatch = useDispatch();
    const hasKPIDeepDive = useSelector((state) => chatGPTReducer.getHasKPIDeepDive(state, targetKPI));
    const KPIDeepDiveStatus = useSelector((state) => chatGPTReducer.getKPIDeepDiveStatus(state, targetKPI));
    return (React.createElement("div", { className: styles.kpiDeepDiveWrapper }, hasKPIDeepDive ? React.createElement(KPIDeepDiveDashboard, { ...props }) : React.createElement(KPIDeepDiveSetup, { ...props })));
};
export default KPIDeepDive;
